<ng-template #ondcModal let-modal>
  <div class="d-flex flex-column overflow-hidden">
    <!-- Modal Header – fixed -->
    <div class="ondc-modal-header d-flex px-3 py-2 justify-content-between align-items-center gap-2 w-100">
      <h4 class="modal-title mb-0">ONDC Config</h4>
      <button type="button" aria-label="Close" class="ad-close-btn" (click)="modal.dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
            d="m7 7l10 10M7 17L17 7" stroke-width="1"></path>
        </svg>
      </button>
    </div>
    <!-- Table body – only this scrolls -->
    <div class="modal-body p-0 overflow-auto flex-grow-1 w-100">
      <div class="table-scroll">
        <table id="ondc-main-table" class="main-table ondc-config-table">
          <thead>
            <tr>
              <th rowspan="2" class="ondc-th-check">
                <div class="d-flex justify-content-start align-items-center gap-2">
                  <div class="ondc-select-all-wrap">
                    <input type="checkbox" id="ondc-select-all" [checked]="isAllOndcSelected"
                      (change)="toggleSelectAllOndc()" class="ondc-check-input">
                    <label for="ondc-select-all" class="ondc-check-label m-0">All</label>
                  </div>
                </div>
              </th>
              <th rowspan="2" class="ondc-th-name text-center">ONDC</th>
              <th colspan="3" class="text-center ondc-distance-group">Distance in km</th>
              <th rowspan="2" class="text-center ondc-th-status">Status</th>
            </tr>
            <tr>
              <th class="text-center ondc-th-km rounded-0">Order Value</th>
              <th class="text-center ondc-th-km rounded-0">Minimum</th>
              <th class="text-center ondc-th-km rounded-0">Maximum</th>
            </tr>
          </thead>
          <tbody>
            @for (provider of ondcProvidersList; track provider.url; let i = $index) {
            <tr class="cursor-pointer" [class.table-active]="provider.selected" (click)="toggleProvider(provider, i)">
              <td class="ondc-td-check">
                <div class="d-flex justify-content-start align-items-center">
                  <input type="checkbox" [id]="'ondc-cb-' + i" class="ondc-check-input" [(ngModel)]="provider.selected"
                    (change)="clearIfDeselected(provider, i)" (click)="$event.stopPropagation()">
                  <label [for]="'ondc-cb-' + i" class="ondc-check-label mb-0"></label>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div class="ondc-provider-logo">
                    @if(provider.logo) {
                    <img [src]="provider.logo" (error)="provider.logo = null" alt="logo">
                    } @else {
                    <span class="ondc-provider-initial">{{provider.name?.charAt(0)?.toUpperCase()}}</span>
                    }
                  </div>
                  <label class="mb-0 cursor-pointer" [for]="'ondc-cb-' + i" (click)="$event.stopPropagation()">
                    {{provider.name}}
                  </label>
                </div>
              </td>
              <td class="text-center">
                <div class="ondc-km-cell">
                  <input type="number" class="ad-form-control ondc-km-input" min="0"
                    [ngModel]="provider.max_order_value"
                    (ngModelChange)="provider.max_order_value = $event < 0 ? null : $event" placeholder="0"
                    appOnlyNumber [title]="'Max Order Value'" [disabled]="!provider.selected"
                    (click)="$event.stopPropagation()">
                  <span class="ondc-km-unit">RS</span>
                </div>
              </td>
              <td class="text-center">
                <div class="ondc-km-cell">
                  <input type="number" class="ad-form-control ondc-km-input" step="0.1" min="0"
                    [ngModel]="provider.min_km"
                    (ngModelChange)="provider.min_km = $event < 0 ? null : $event; validateKmRange(i)" placeholder="0"
                    appOnlyNumber [title]="'Min KM'" [disabled]="!provider.selected" (click)="$event.stopPropagation()">
                  <span class="ondc-km-unit">km</span>
                </div>
              </td>
              <td class="text-center">
                <div class="ondc-km-cell">
                  <input type="number" class="ad-form-control ondc-km-input" step="0.1" min="0"
                    [ngModel]="provider.max_km"
                    (ngModelChange)="provider.max_km = $event < 0 ? null : $event; validateKmRange(i)" placeholder="0"
                    appOnlyNumber [title]="'Max KM'" [disabled]="!provider.selected" (click)="$event.stopPropagation()">
                  <span class="ondc-km-unit">km</span>
                </div>
              </td>
              <td class="text-center">
                <span class="ondc-status-badge"
                  [ngClass]="provider.status === 'Active' ? 'ondc-status-active' : 'ondc-status-inactive'">
                  {{ provider.status || 'Inactive' }}
                </span>
              </td>
            </tr>
            @if (kmValidationErrors[i]) {
            <tr>
              <td colspan="5" class="p-0 border-0">
                <div class="km-validation-error">
                  <p class="mb-0 ad-errors">{{kmValidationErrors[i]}}</p>
                </div>
              </td>
            </tr>
            }
            }
          </tbody>
        </table>
      </div>
    </div>
    <!-- Modal Footer – fixed -->
    <div class="d-flex justify-content-end gap-2 px-3 py-2 border-top w-100">
      <!-- <button type="button" class="btn ad-btn-small active" (click)="saveOndcConfig()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
                <path stroke-linecap="round" d="M15 13h-3m0 0H9m3 0v-3m0 3v3" />
              </g>
            </svg>
            <span>Add</span>
          </button> -->
      <button type="button" class="btn ad-btn-small active" (click)="saveOndcConfig()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <g fill="none">
            <g clip-path="url(#ondcUpdateIcon0)">
              <path fill="currentColor" fill-rule="evenodd"
                d="M2.035 3.25c.33-2.221 2.1-4 4.346-4C7.726-.75 8.914-.1 9.71.892a.75.75 0 1 1-1.17.938C7.998 1.154 7.224.75 6.38.75c-1.326 0-2.52 1.03-2.826 2.506a.75.75 0 0 1 .459 1.25l-.73.8a.75.75 0 0 1-1.108 0l-.73-.8a.75.75 0 0 1 .59-1.255M12.25 2a.75.75 0 0 1 .752-.748c1.547.004 2.8.03 3.807.2c1.028.175 1.872.512 2.55 1.19c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v4.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153h-.112c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-3.055a.75.75 0 0 1 1.5 0V14c0 1.907.002 3.262.14 4.29c.135 1.005.389 1.585.812 2.008s1.003.677 2.009.812c1.028.138 2.382.14 4.289.14s3.262-.002 4.29-.14c1.005-.135 1.585-.389 2.008-.812s.677-1.003.812-2.009c.138-1.027.14-2.382.14-4.289v-4c0-1.907-.002-3.261-.14-4.29c-.135-1.005-.389-1.585-.812-2.008c-.385-.385-.898-.629-1.74-.772c-.864-.146-1.993-.174-3.56-.18A.75.75 0 0 1 12.25 2m-1.98.451a.75.75 0 0 1 .554.244l.73.8a.75.75 0 0 1-.59 1.255c-.328 2.221-2.098 4-4.344 4c-1.25 0-2.368-.562-3.158-1.44a.75.75 0 1 1 1.115-1.004c.534.594 1.258.944 2.043.944c1.326 0 2.52-1.03 2.826-2.506a.75.75 0 0 1-.459-1.25l.73-.8a.75.75 0 0 1 .554-.244M8.25 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75"
                clip-rule="evenodd" />
            </g>
            <defs>
              <clipPath id="ondcUpdateIcon0">
                <path fill="#fff" d="M0 0h24v24H0z" />
              </clipPath>
            </defs>
          </g>
        </svg>
        <span>Update</span>
      </button>
    </div>
  </div>
</ng-template>